import React, { Component } from 'react';
import '../landing.css'
import './slideshow.css'
import Navbar from "../navbar";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import YouTube from 'react-youtube';
import congo from './images/congo.svg'


export default class facebook extends Component {
    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
    constructor(props) {
        super(props);
        const windowSize = window.innerWidth;
        let a = (windowSize) - 100;
        let b = (windowSize) - 250;
        if (windowSize < 800) {
            if (windowSize > 600) {
                this.state = {
                    height: b.toString(),
                    width: a.toString(),
                    playerVars: {
                        autoplay: 0,
                    }
                };
            }
            else {
                b = windowSize;
                this.state = {
                    height: b.toString(),
                    width: a.toString(),
                    playerVars: {
                        autoplay: 0,
                    }
                };
            }

        }
        else {
            this.state = {
                height: '400',
                width: '760',
                playerVars: {
                    autoplay: 0,
                }
            };
        }

    }


    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }
    componentDidUpdate() {
        window.addEventListener("resize", this.handleResize);

    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    handleResize = () => {
        window.location.reload(false);
        const windowSize = window.innerWidth;
        let a = (windowSize) - 100;
        let b = (windowSize) - 250;
        if (windowSize < 800) {
            if (windowSize > 600) {
                this.setState(
                    {
                        height: b.toString(),
                        width: a.toString()
                    }
                );
            }
            else {
                b = windowSize;
                this.setState(
                    {
                        height: b.toString(),
                        width: a.toString()
                    }
                );
            }

        }
        else {
            this.setState(
                {
                    height: '400',
                    width: '760'
                }
            );
        }

        console.log(a.toString());
        console.log(this.state.height);
    };
    render() {
        const opts = {
            height: '400',
            width: '760',
            playerVars: {
                autoplay: 0,
            },
        };
        return (
            <div class="page">
                <div class="banner">
                    <Navbar />
                    <OwlCarousel className='owl-theme' loop margin={10} nav autoWidth={true} center>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                                <div class="video">
                                    <YouTube videoId="KYKh2SFQtEA" opts={this.state} onReady={this._onReady} style={{ position: "relative", margin: "auto", left: "3%", zIndex: "-100" }} />
                                </div>

                                <p class="description" style={{ margin: "auto", width: "95%" }}>Click on <i class="fa fa-youtube-play"> </i> to get in depth instructions to use facebook and get ready for next level experience of facebook.</p>
                            </div>

                        </div>

                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                                <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img f-1" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>Open facebook by clicking on this <a class="link" href="https://www.facebook.com/">link</a>.A page will open. Navigate to signin button at top right.</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img f-2" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>After succesfull sigin to facebook you will be redirected to the home page where you can watch recent posts, search and add friends to your friend list</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img f-3" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>To search and add friend click on the search bar at the top and search by the name.</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img f-4" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>After cliking on search icon a search list will be displayed, find yourrequired friend and family and click on <i class="material-icons">person_add</i> to add your friend.</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img f-5" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>Now you will see recent posts of your family and friends, You can like post by clicking on <i class="fa fa-thumbs-up"></i> icon or leave a comment by clicking  on <i class="fa fa-comment"></i> icon or send post to other by<i class="fa fa-send"></i></p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img f-6" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>You can add new post by clicking new post icon and adding stuff to your post and click send button</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                                <img style={{ width: "95%", margin: "auto", zIndex: "-100" ,height:"360px" }} class="tut-img" src={congo} alt="tut1"></img>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>Yippe you are all set to use facebook and surf different post and follow live pages. <br/> <br/></p>
                            </div>

                        </div>

                    </OwlCarousel>

                </div>
            </div>);
    }

}